// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../Core.Generator/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer-contact[data-v-6e87eea9]{display:flex;flex-direction:column;margin:0 4rem;padding:1rem 0;width:10rem}.footer-contact__title[data-v-6e87eea9]{color:var(--core__footer-font_color);font-size:18px;font-weight:700;line-height:24px;-webkit-text-decoration:underline;text-decoration:underline;text-decoration-color:var(--core__footer-contact-underline_color);text-decoration-thickness:2px;text-underline-offset:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
